module.exports = __webpack_public_path__ + "img/thumbnail_LarGibbon_f_albino.f3a49db4.png";